// extracted by mini-css-extract-plugin
export default {"commonExternalSearchCatalogFooter__button":"styles_common-external-search-catalog-footer__button__BHnFj"};